import { ReactNode } from 'react';
import styled from 'styled-components';

interface FlexProps {
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  justify?: 'start' | 'end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  align?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';

  gap?: number | string;
  width?: string | number;
  height?: string | number;
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
}

interface StyledFlexProps {
  $direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  $justify?: 'start' | 'end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  $align?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
  $wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  $gap?: number | string;
  $width?: string | number;
  $height?: string | number;
}

const Flex = styled.div<StyledFlexProps>`
  display: flex;
  
  flex-direction: ${({ $direction }) => $direction || 'row'};
  
  justify-content: ${({ $justify }) => {
    switch ($justify) {
      case 'start':
        return 'flex-start';
      case 'end':
        return 'flex-end';
      case 'center':
        return 'center';
      case 'space-between':
        return 'space-between';
      case 'space-around':
        return 'space-around';
      case 'space-evenly':
        return 'space-evenly';
      default:
        return 'flex-start';
    }
  }};
  
  align-items: ${({ $align }) => {
    switch ($align) {
      case 'start':
        return 'flex-start';
      case 'end':
        return 'flex-end';
      case 'center':
        return 'center';
      case 'stretch':
        return 'stretch';
      case 'baseline':
        return 'baseline';
      default:
        return 'stretch';
    }
  }};
  
  flex-wrap: ${({ $wrap }) => $wrap || 'nowrap'};
  
  gap: ${({ $gap }) => {
    if (typeof $gap === 'number') {
      return `${$gap}px`;
    }
    return $gap || '0';
  }};
  
  width: ${({ $width }) => {
    if (typeof $width === 'number') {
      return `${$width}px`;
    }
    return $width || 'auto';
  }};
  
  height: ${({ $height }) => {
    if (typeof $height === 'number') {
      return `${$height}px`;
    }
    return $height || 'auto';
  }};
`;

export const UiFlex: React.FC<FlexProps> = (props) => {
  return (
    <Flex
      className={props.className}
      $direction={props.direction}
      $justify={props.justify}
      $align={props.align}
      $wrap={props.wrap}
      $gap={props.gap}
      $width={props.width}
      $height={props.height}
      onClick={props.onClick}
    >
      {props.children}
    </Flex>
  );
};
